import { withInjection } from "/src/components/ui/util/with-injection";
import { CardHome } from "/src/pages/card-home/CardHome";
import { APP_DEP } from "/src/config/configure-dependencies";
import { CardHomeProps } from "./CardHome";

export const InjectedCardHome = withInjection<
  CardHomeProps,
  | "bankingWebCardService"
  | "bankingWebComplianceService"
  | "bankingWebService"
  | "cardManagementService"
  | "externalBizbankService"
  | "personProfileService"
  | "userCardInvitationService"
  | "webService"
>(CardHome, {
  bankingWebCardService: APP_DEP.BANKING_WEB_CARD_SERVICE,
  bankingWebComplianceService: APP_DEP.BANKING_WEB_COMPLIANCE_SERVICE,
  bankingWebService: APP_DEP.BANKING_WEB_SERVICE,
  cardManagementService: APP_DEP.CARD_MANAGEMENT_SERVICE,
  externalBizbankService: APP_DEP.EXTERNAL_BIZBANK_SERVICE,
  personProfileService: APP_DEP.PERSON_PROFILE_SERVICE,
  userCardInvitationService: APP_DEP.USER_CARD_INVITATION_SERVICE,
  webService: APP_DEP.WEB_SERVICE,
});
